<input type="text" class="form-control" [(ngModel)]="searchQuery" (keyup)="inputkeyUp()" (keydown)="inputKeyDown()"
placeholder="Search" aria-label="Search" aria-describedby="search-addon">